import { CNav } from './CNav.js';
import { CNavGroup } from './CNavGroup.js';
import { CNavGroupItems } from './CNavGroupItems.js';
import { CNavItem } from './CNavItem.js';
import { CNavLink } from './CNavLink.js';
import { CNavTitle } from './CNavTitle.js';

const CNavPlugin = {
    install: (app) => {
        app.component(CNav.name, CNav);
        app.component(CNavGroup.name, CNavGroup);
        app.component(CNavGroupItems.name, CNavGroupItems);
        app.component(CNavItem.name, CNavItem);
        app.component(CNavLink.name, CNavLink);
        app.component(CNavTitle.name, CNavTitle);
    },
};

export { CNav, CNavGroup, CNavGroupItems, CNavItem, CNavLink, CNavPlugin, CNavTitle };
//# sourceMappingURL=index.js.map
